import Input from "./Input";
import Checkbox from "./Checkbox";
import Table from "./Table";

export default function ComponentsOverrides(theme) {
  return Object.assign(Input(theme), Checkbox(theme), Table(theme));
}
